<template>
  <div class="msg">{{ messageText }}</div>
</template>

<script>
export default {
  name: 'MsgEntityNotFound',
  props: {
    message: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: 'data',
    },
  },
  computed: {
    messageText() {
      return this.message ? this.message : `The ${this.name} has not been created or published yet.`;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.msg {
  padding-top: 50px;
  color: vars.$c-dark-gray;
  font-size: 16px;
  font-weight: 400;

  @media (min-width: vars.$tablet-break-point) {
    font-size: 24px;
  }
}
</style>
